// "use strict";

class Validator {
  email(value) {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (filter.test(value)) {
        return true;
    } else {
        return false;
    }
  }

  required(value) {
    if(value  === null || value.toString().trim() === '') {
      return false;
    }
    return true;
  }

  minLength(value, length) {
    if(value.length >= length) {
      return true;
    }
    return false;
  }

  maxLength(value, length) {
    if(value.length <= length) {
      return true;
    }
    return false;
  }

  match(value1, value2) {
    if(value1 === value2) {
      return true;
    }

    return false;
  }

  number(value) {
    var regex = /^\d+$/;
    return (regex.test(value));
  }

  alphanumeric(value) {
      var letters = /^[0-9a-zA-Z]+$/;
      if(value.match(letters)){
          return true;
      }
      return false;
  }
}

export default Validator;
